import { BlogDetails } from './../../Classes/blogs-model';
import { BlogsService } from './../../Services/blog.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-blogs-details',
  templateUrl: './blogs-details.component.html',
  styleUrls: ['./blogs-details.component.css']
})
export class BlogsDetailsComponent implements OnInit {
  blogDetails: BlogDetails;
  isLoading = false;
  
  constructor(
    private _blogService: BlogsService,
    private activateRoute: ActivatedRoute,
    private router: Router
  ) { }
  
  ngOnInit(): void {
    // Get the title from URL
    const urlTitle = this.activateRoute.snapshot.params['title'];
    
    // We need to convert this title to an ID
    this.findBlogIdByTitle(urlTitle);
  }

  findBlogIdByTitle(urlTitle: string) {
    this.isLoading = true;
    
    // Get all blogs to find the one with matching URL title
    this._blogService.getBlogList('', 0, 100).subscribe(
      response => {
        
        const formatForUrl = (title: string) => {
          if (!title) return '';
          return title
            .toLowerCase()
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-');
        };
        
        const foundBlog = response.data.find(blog => 
          formatForUrl(blog.title) === urlTitle
        );
        
        if (foundBlog) {
          this.getBlogById(foundBlog.id);
        } else {
          console.error('Blog not found with title:', urlTitle);
          this.isLoading = false;
          this.router.navigate(['/blogs/list']);
        }
      },
      error => {
        console.error('Error fetching blogs list:', error);
        this.isLoading = false;
      }
    );
  }

  getBlogById(id: number) {
    this._blogService.getBlogById(id).subscribe(
      response => {
        this.blogDetails = response;
        this.isLoading = false;
      },
      error => {
        console.error('Error fetching blog details:', error);
        this.isLoading = false;
      }
    );
  }
}